// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3Rmrl","search":"Settings_search__3FbCd","filter":"Settings_filter__1-RFi"};